import { fromJS } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { ANALYTICS_TARGETED_CONTENT } from 'reporting-data/constants/dataTypes';
import { EQ } from 'reporting-data/constants/operators';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import useReportingContentIds from '../../../hooks/useReportingContentIds';
import { useReportingFiltersProvider } from '../../../providers/ReportingFiltersProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const renderCustomRow = ({
  value
}) => {
  const internalKey = value === 'default' ? 'content-management-details-lib.reporting.smartContentTable.defaultLabel' : 'content-management-details-lib.reporting.smartContentTable.smartLabel';
  const message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: internalKey
  });
  if (value === 'default') {
    return /*#__PURE__*/_jsx("td", {
      children: message
    });
  }
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.reporting.smartContentTable.smartLabelTooltip"
      }),
      children: message
    })
  });
};
const getReport = ({
  contentId,
  dateRange,
  metricsToDisplay
}) => {
  const metricsList = metricsToDisplay.map(metric => ({
    property: metric
  }));
  return {
    chartType: TABLE,
    config: {
      configType: AGGREGATION,
      dataType: ANALYTICS_TARGETED_CONTENT,
      dimensions: ['breakdown'],
      filters: {
        custom: [{
          operator: EQ,
          property: 'pageId',
          value: contentId
        }],
        dateRange: {
          property: 'sessionDate',
          value: dateRange
        }
      },
      metrics: metricsList
    },
    displayParams: {
      columns: {
        breakdown: {
          render: renderCustomRow
        }
      }
    }
  };
};
const SmartContentTable = ({
  metricsToDisplay
}) => {
  const {
    dateRange
  } = useReportingFiltersProvider();
  const {
    contentId
  } = useReportingContentIds({});
  const report = getReport({
    contentId,
    dateRange,
    metricsToDisplay
  });
  if (!report) {
    return null;
  }
  return /*#__PURE__*/_jsx(CardWrapper, {
    compact: true,
    children: /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(PlatformReportResolver, {
        report: fromJS(report),
        useInlineLabels: false
      })
    })
  });
};
export default SmartContentTable;